import { z } from "zod";
import { CustomDomain } from "../custom-domains";
import { Asset } from "../dsm/assets/asset";
import { DataSource } from "../dsm/data-sources/data-source";
import { DesignSystem } from "../dsm/design-system";
import { DesignSystemVersionDump } from "./design-system-version-dump";

export const DesignSystemDump = z.object({
  designSystem: DesignSystem,
  dataSources: DataSource.array(),
  versions: DesignSystemVersionDump.array(),
  customDomain: CustomDomain.optional(),
  files: Asset.array(),
});

export type DesignSystemDump = z.infer<typeof DesignSystemDump>;
